import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { useTranslation } from 'react-i18next';
import useNotification from 'containers/App/Notifications/useNotification';
import { ELEVES_ACCOUNT_KEY } from 'queries/eleves/useEleves';

function updateClassroom({
  schoolyearId,
  schoolId,
  classroom,
}: {
  schoolyearId: string;
  schoolId: string;
  classroom: Classroom;
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/classrooms/${classroom.id}`,
    { method: 'PATCH', body: classroom },
  );
}

export default function useUpdateClassroom(
  schoolyearId: string,
  schoolId: string,
) {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['schoolyearSettings']);

  const { mutateAsync } = useMutation({
    mutationFn: (classroom: Classroom) =>
      updateClassroom({
        schoolyearId,
        schoolId,
        classroom,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY],
      });
      // invalidate eleves because groupNames is built using classroom names
      queryClient.invalidateQueries({
        queryKey: [ELEVES_ACCOUNT_KEY, schoolyearId, schoolId],
      });
    },
    onError: () => {
      notifyError({
        title: t('schoolyearSettings:messages.classroom.updateError'),
      });
    },
  });
  return mutateAsync;
}
